/**
 * ITT-900: beer ingestion failure queue helpers for Engage UI.
 */

export const BEER_INGESTION_FAILURE_CATEGORY_LABELS = {
  monitor_check_error: 'Monitor check failed',
  extract_scrape_failed: 'Scrape failed',
  extract_normalize_failed: 'Normalize failed',
  extract_stuck: 'Extract stuck',
  comparison_failed: 'Compare failed',
};

export const BEER_INGESTION_FAILURE_RETRY_LABELS = {
  monitor_check_error: 'Check now',
  extract_scrape_failed: 'Check now',
  extract_stuck: 'Check now',
  extract_normalize_failed: 'Retry processing',
  comparison_failed: 'Recompare',
};

export const BEER_INGESTION_PAUSED_REASON_REPEATED_FAILURES = 'repeated_failures';

export function formatBeerIngestionFailureCategoryLabel(category) {
  return BEER_INGESTION_FAILURE_CATEGORY_LABELS[category] || category || 'Unknown';
}

export function primaryRetryLabelForCategory(category) {
  return BEER_INGESTION_FAILURE_RETRY_LABELS[category] || 'Retry';
}

export function isRetryDisabled(failureItem) {
  if (!failureItem || failureItem.disposition === 'resolved') {
    return true;
  }
  return failureItem.retryState === 'in_progress';
}

export function truncateFailureError(message, maxLength = 120) {
  const trimmed = typeof message === 'string' ? message.trim() : '';
  if (!trimmed) {
    return '—';
  }
  if (trimmed.length <= maxLength) {
    return trimmed;
  }
  return `${trimmed.slice(0, maxLength - 1)}…`;
}

export function countAutoPausedOpenFailures(rows) {
  if (!Array.isArray(rows)) {
    return 0;
  }
  return rows.filter(
    (row) => row.disposition === 'open' && row.autoPaused === true,
  ).length;
}

export function failureRetryHelperCopy(category) {
  if (category === 'extract_normalize_failed') {
    return 'Retry processing reuses stored raw beers without recrawling.';
  }
  if (category === 'comparison_failed') {
    return 'Recompare runs snapshot diff only; it does not recrawl.';
  }
  return 'Check now triggers a new monitor check and may recrawl when the page changed.';
}
